/**
 * TIR-EPD REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tirepd@iru.org
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HaulierTIRAccessGuaranteeQuota } from './haulierTIRAccessGuaranteeQuota';
import { AssociationOffice } from './associationOffice';
import { HaulierInternationalLicence } from './haulierInternationalLicence';


export interface HaulierTIRAccess { 
    associationStatus?: HaulierTIRAccess.AssociationStatusEnum;
    internationalLicence?: HaulierInternationalLicence;
    guaranteeQuota?: HaulierTIRAccessGuaranteeQuota;
    offices?: Array<AssociationOffice>;
    etirAddendumIndicator?: boolean;
}
export namespace HaulierTIRAccess {
    export type AssociationStatusEnum = 'applicant' | 'refused' | 'admitted' | 'pending-suspension' | 'temporary-suspended' | 'permanently-suspended' | 'inactive';
    export const AssociationStatusEnum = {
        Applicant: 'applicant' as AssociationStatusEnum,
        Refused: 'refused' as AssociationStatusEnum,
        Admitted: 'admitted' as AssociationStatusEnum,
        PendingSuspension: 'pending-suspension' as AssociationStatusEnum,
        TemporarySuspended: 'temporary-suspended' as AssociationStatusEnum,
        PermanentlySuspended: 'permanently-suspended' as AssociationStatusEnum,
        Inactive: 'inactive' as AssociationStatusEnum
    };
}


